// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mM-z","isFullWidth":"nM-z","landingPageVideo":"oM-z","play":"pM-z","iframeVideo":"qM-z","playHidden":"rM-z","fullwidth":"sM-z"};